export enum LoanOfferIndicatorsText {
  GrossLoan = 'Gross Loan',
  CashToYou = 'Cash to You',
  APR = 'APR',
  FixedRate = 'Fixed Rate',
  TermYears = 'Term (years)',
  MonthlyPayment = 'Monthly Payment',
}
